import React from 'react';
import { Container } from '@material-ui/core';
import GitInfo from 'react-git-info/macro';
import TextElement from '../elements/TextElement';
import styled, { keyframes } from 'styled-components';

function HanuLoading() {
    const gitInfo = GitInfo();

    return (
        <Container maxWidth="xs" className="container-static">
            <DotPulseLoading/>
            <RightBottomVersion>
                <TextElement text={gitInfo.tags[0]} type="body-1" uppercase="uppercase" bold={true}/>
            </RightBottomVersion>
        </Container>
    );
};

const DotPulseBefore = keyframes`
    0% {
        box-shadow: 9984px 0 0 -5px;
    }
    30% {
        box-shadow: 9984px 0 0 2px;
    }
    60%, 100% {
        box-shadow: 9984px 0 0 -5px;
    }
`

const DotPulseAfter = keyframes`
    0% {
        box-shadow: 10014px 0 0 -5px;
    }
    30% {
        box-shadow: 10014px 0 0 2px;
    }
    60%, 100% {
        box-shadow: 10014px 0 0 -5px;
    }
`

const DotPulse = keyframes`
    0% {
        box-shadow: 10014px 0 0 -5px;
    }
    30% {
        box-shadow: 10014px 0 0 2px;
    }
    60%, 100% {
        box-shadow: 10014px 0 0 -5px;
    }
`

const DotPulseLoading = styled.div`
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #ffffff;
  color: #000;
  box-shadow: 9999px 0 0 -5px;
  animation: ${DotPulse} 1.5s infinite linear;
  animation-delay: 0.25s;

  &:after, &:before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #ffffff;
    color: #000;
  }

  &:after {
    box-shadow: 10014px 0 0 -5px;
    animation: ${DotPulseAfter} 1.5s infinite linear;
    animation-delay: 0.5s;
  }

  &:before {
    box-shadow: 9984px 0 0 -5px;
    animation: ${DotPulseBefore} 1.5s infinite linear;
    animation-delay: 0s;
  }
`;

const RightBottomVersion = styled.div`
    position: absolute;
    bottom: 0;
    right: 35px;
`;

export default HanuLoading;
